import { render, staticRenderFns } from "./file-preview.vue?vue&type=template&id=c40e479a&"
import script from "./file-preview.vue?vue&type=script&lang=ts&"
export * from "./file-preview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/survey-library/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c40e479a')) {
      api.createRecord('c40e479a', component.options)
    } else {
      api.reload('c40e479a', component.options)
    }
    module.hot.accept("./file-preview.vue?vue&type=template&id=c40e479a&", function () {
      api.rerender('c40e479a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/components/file/file-preview.vue"
export default component.exports